import { PreviewMediaType } from '@/types';

import type { LibraryItem } from '@/types';

export interface PresetShareTarget {
  slug: string;
  title?: string;
  description?: string;
  previewUrl?: string;
}

/**
 * Narrows a library item to the fields a share link carries.
 *
 * `previewUrl` becomes the link's OG image, so it has to be a still: video
 * presets carry an `.mp4` in `media.url` and unfurlers render no picture for it.
 * Deliberately not passed through `optimizeImageUrl` either — that forces
 * `type=webp`, which WhatsApp in particular fails to preview.
 */
const toShareTarget = (item: LibraryItem): PresetShareTarget => ({
  slug: item.slug,
  title: item.title,
  description: item.description,
  previewUrl:
    item.type === PreviewMediaType.VIDEO ? item.media.poster : item.media.url,
});

export default toShareTarget;
